<script>
/**
 * --------------------------------------------------
 * snippet untuk lanjut chat / reopen
 * --------------------------------------------------
 */

import { request } from "@/common/mixins/mix_helper";
import { loader } from "@/common/mixins/mix_loader";
import { clientCookies } from "@/common/mixins/mix_cookies";
import { mapGetters } from "vuex";

export default {
  name: "ContinueChat",
  mixins: [loader, request, clientCookies],
  methods: {
    onContinue() {
      this.loading();
      this.API.get(this.URL.client.continue)
        .then(({ data }) => {
          const config = {
            rating: { uuid: null, endtime: null },
            isContinueChatEnabled: false,
            // config.isMore24Hour=  data.is_reset,
          };

          if (typeof data.is_open !== "undefined") {
            config.isClosed = false;
            config.isChatAreaEnabled = true;
          }

          this.cookiesSyncUpdate(config);
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        })
        .finally(() => {
          this.loading(false);
        });
    },
  },
  computed: {
    ...mapGetters(["getConfigJs"]),
  },
};
</script>

<template>
  <div class="flex items-end justify-center">
    <button
      class="btn btn-primary rw-bg-3 border-0 d-flex items-center gap-2 btn-sm"
      type="button"
      @click="onContinue"
    >
      <span class="material-symbols-outlined">comment</span>
      <span> Lanjutkan Chat</span>
    </button>
  </div>
</template>
